import { render, staticRenderFns } from "./FormMicrositio.vue?vue&type=template&id=733d19f0&"
import script from "./FormMicrositio.vue?vue&type=script&lang=js&"
export * from "./FormMicrositio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports